// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0f4c789e]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.list-header[data-v-0f4c789e],.main[data-v-0f4c789e]{display:flex}.list-header[data-v-0f4c789e]{align-items:center;justify-content:space-between}.main[data-v-0f4c789e]{margin-top:20px}.main .main-left[data-v-0f4c789e]{flex:0 0 240px;margin-right:16px;border-bottom:1px solid #eee}.main .main-right[data-v-0f4c789e]{flex:1;overflow:hidden}", ""]);
// Exports
module.exports = exports;
